import { Directive, TemplateRef } from '@angular/core';

/**
 * Slot pra linha-footer "adicionar item". Quando presente, o componente
 * renderiza a footer row com ícone "+" na 1ª coluna e o template projetado
 * na 2ª coluna (geralmente um <app-user-search>). Quando ausente, sem
 * footer-add.
 *
 * Uso: `<ng-template appPeopleTableFooterAdd>...</ng-template>`
 */
@Directive({ selector: '[appPeopleTableFooterAdd]' })
export class PeopleTableFooterAddDirective {
  constructor(public template: TemplateRef<any>) { }
}

/**
 * Slot pras ações por linha (cluster de icon-buttons na coluna "Ações").
 * Recebe a row corrente via `let-row`. Quando ausente, a coluna actions
 * não é renderizada.
 *
 * Uso: `<ng-template appPeopleTableRowActions let-row>...</ng-template>`
 */
@Directive({ selector: '[appPeopleTableRowActions]' })
export class PeopleTableRowActionsDirective {
  constructor(public template: TemplateRef<any>) { }
}

/**
 * Slot pras ações em lote (barra de ações flutuante). Recebe a lista de
 * linhas selecionadas via `let-selected`. Quando ausente, sem floating bar.
 *
 * Uso: `<ng-template appPeopleTableBatchActions let-selected="selected">...</ng-template>`
 */
@Directive({ selector: '[appPeopleTableBatchActions]' })
export class PeopleTableBatchActionsDirective {
  constructor(public template: TemplateRef<any>) { }
}
